import cheader from '@/components/header/index.vue'
import elTableInfiniteScroll from 'el-table-infinite-scroll';
export default {
  directives: {
    'el-table-infinite-scroll': elTableInfiniteScroll
  },
  name: 'order',
  data() {
    return {
      serverUrl: this.$store.state.config.serverUrl,
      isChecked: true,
      order: {
        pay: {},
        endValue: '',
        createBy: {},
        updateBy: {},
        productList: []
      },
      search: {
        name: ''
      },
      pageNo:0,
      pageSize:20,
      total:0,
      curpage: 1,
      sizes:"14px",
      loading:true,
      disabled:false,
      pageOption:[{
          value:20,
          label:"20"
      },{
        value:100,
        label:"100"
      },{
        value:500,
        label:"500"
    }],
      subGoods: []
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    goodsFilter() {
      return this.order.productList.filter((item) => {
        return item.product.name.indexOf(this.search.name) != -1
      })
    }
  },
  created() {
  //  this.index()
  },
  components: {
    cheader
  },
  methods: {
    load(){
      if(this.disabled==false){
        this.pageNo+=1
        this.index()
      }
    },
    changeFont(type){
      if(type==0){
        this.sizes = "14px"
      }else{
        this.sizes = "16px"
      }
   },
    go(url) {
      this.$router.push(url)
    },
    handlePageChange(val){
      this.loading = true
      this.pageNo = val
      this.index()
    },
    handleSizeChange(val){
      this.loading = true
      this.pageSize = val
      this.index()
    },
    inputs(){
      this.loading=true
      this.pageNo = 1
      this.subGoods = []
      this.index()
    },
    changeIndex(){
      this.pageNo = 1
      this.subGoods = []
      this.index()
    },
    
    index() {
      var _this = this
      this.loading = true
      this.disabled = true
      var params = {
        id: this.$route.params.id,
        userId:  this.user.id,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        otherParam:this.search.name,
        orderBy: ""
      }
      this.$http.get('/api/inquiry/viewOfferHistory', {
        params: params
      }).then((res) => {
        this.loading=false
        this.disabled = false
        this.total = res.data.total
        if(res.data.data.productList!=""){
          res.data.data.productList.forEach(function(item,index){
            if(item.supProductList[0].isNewRecord==false){
               // 获取到value最小的那个值 如果是获取最大值 min 改成max
               const minMathData =( Math.min.apply(Math,item.supProductList.map(item => { 
                 if(item.ticket!=undefined){
                   return parseFloat(item.ticket)
                 }else{
                   return parseFloat(item.unticket)
                 }
                })));
                
               // 获取最小值信息
               const minData = item.supProductList.find(item => minMathData === (item.ticket==undefined?parseFloat(item.unticket):parseFloat(item.ticket)))
               item.radios =minData.supplier.id+","+minData.id+","+minData.productId
              _this.$forceUpdate()
              _this.$set(res.data.data.productList,index,item)
            }
          })
        }
        
        res.data.data.supplierProductList ? '' : res.data.data.supplierProductList = []
        this.order = res.data.data
        switch (this.order.pay.value) {
          case 'cash':
            this.order.pay.value = '现金'
            break
          case 'card':
            this.order.pay.value = '银行卡'
            break
          case 'alipay':
            this.order.pay.value = '支付宝'
            break
          case 'wechat':
            this.order.pay.value = '微信'
            break
        }
      
        for (let item of this.order.productList) {
          // if (item.ticket < item.enquiryTicket) {
          //   console.log(typeof item.ticket)
          //   console.log(typeof item.ticket)
          // }
          item.available = item.available ? item.available : item.expected
          item.ticket = item.ticket ? item.ticket : '0'
          item.unticket = item.unticket ? item.unticket : '0'
          
          item.color = 'simple'
          if (!item.enquiryTicket) {
            continue
          }

          
        }
        let arr = []
        if(this.order.productList!=""){
          this.subGoods = this.subGoods.concat(this.order.productList) //上拉加载新数据添加到数组中
        }
        this.subGoods.map((item,index) => {
          arr.push(item)
          if (arr.filter((itemer) => {
            return itemer.productId == item.productId
          }).length > 1) {
            return 'noid'
          } else {
            return item.id
          }
        })
        this.subGoods = new Set(this.subGoods)
        this.subGoods = [...this.subGoods]
        this.subGoods.forEach((item, index, arr) => {
          if (item == 'noid') {
            arr.splice(index, 1)
          } else if (!item) {
            arr.splice(index, 1)
          }
        }) 

        this.order.productList = this.subGoods
        if(res.data.data.productList=="" || res.data.data.productList.length < this.pageSize || this.subGoods.length == res.data.total) {
            this.disabled = true
        }
      })

    },
    changeValue(row,parent){
      parent.radios = row.supplier.id+','+row.id+','+row.productId
      this.$set(parent,"radios",row.supplier.id+','+row.id+','+row.productId)
      this.$forceUpdate() 
    },
    cancel(row){
      row.radios = ""
      this.$set(row,"radios","")
      this.$forceUpdate() 
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        let rows = this.order.productList.filter((item) => {
          return item.productId == row.productId
        })
        if (rows.indexOf(row) == 0) {
          return {
            rowspan: rows.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      
      return sums
    },
    submit() {
      let arr = []
      this.order.productList.forEach(function(res){
         if(res.radios!=""){
           arr.push(res.radios)
         }
      })
      this.$http.post('/api/inquiry/saveEnquiry', {
        userId: this.user.id,
        inquiryId: this.$route.params.id,
        data: arr
      }).then((res) => {
        if (res.data.success) {
          this.$router.push(`/order/result/${res.data.data}`)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/order/historyOrder/index.js